import { useRouter } from 'next/router'
import { PLANS, BillingTab as View, WORKSPACE_TAB } from 'ui-components'
import { getWorkspaceLink } from 'utils'
import { useGetBillingPortalSession } from '~workspace/queries/useGetBillingPortalSession'
import { useGetCurrentWorkspace } from '~workspace/queries/useGetWorkspaceById'

export function Billing() {
  const router = useRouter()
  const { data } = useGetCurrentWorkspace()
  const mutation = useGetBillingPortalSession()

  const handleBillingUpdate = async () => {
    if (!data) return
    const { url } = await mutation.mutateAsync({
      input: {
        workspaceId: data.id,
        workspaceName: data.name,
        stripeCustomerId: data.stripeCustomerId
      }
    })

    if (!url) throw new Error('Failed to get billing portal session')
    router.push(url)
  }

  const handleMemberClick = () => {
    if (data) {
      router.push(
        getWorkspaceLink({
          workspaceId: data.id,
          workspaceName: data.name,
          tab: WORKSPACE_TAB.MEMBERS,
          page: 1
        })
      )
    }
  }

  return (
    <View
      plan={data?.plan || PLANS.free.name}
      onBillingUpdate={handleBillingUpdate}
      onMembersClick={handleMemberClick}
    />
  )
}
